import { useEffect, useRef } from 'react';
import socket, { connectSocket } from './socket';

/** Keep the shared socket joined to the active group after every reconnect. */
export default function useGroupSocket(groupId, { enabled = true, onConnect } = {}) {
  const onConnectRef = useRef(onConnect);

  useEffect(() => {
    onConnectRef.current = onConnect;
  }, [onConnect]);

  useEffect(() => {
    const normalizedGroupId = Number(groupId);
    if (!enabled || !normalizedGroupId) return undefined;

    const joinGroup = () => {
      socket.emit('join-group', normalizedGroupId);
      onConnectRef.current?.();
    };

    connectSocket();
    socket.on('connect', joinGroup);
    if (socket.connected) joinGroup();

    return () => socket.off('connect', joinGroup);
  }, [enabled, groupId]);
}
